import React, { useState, useEffect, useRef } from "react";
import "./Dashboard.css";

import DashboardSummary from "../../features/Employee/DashboardSummary";
import LatestMembers from "../../features/Employee/LatestMembers";
import AttendanceWidget from "../../features/Employee/AttendanceWidget";
function Dashboard() {
  return (
    <div className='employee-dashboard'>
      <div className='dashboard-item'>
        <DashboardSummary />
      </div>
      <div className='dashboard-item'>
        <LatestMembers />
      </div>
      <div className='dashboard-item'>
        <AttendanceWidget />
      </div>
    </div>
  );
}

export default Dashboard;
